
import { motion } from 'framer-motion';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Brain, Terminal, Zap } from 'lucide-react';
import { ReactNode } from 'react';

interface Challenge {
  id: number;
  title: string;
  description: string;
  isActive: boolean;
  isCompleted: boolean;
  icon: ReactNode;
}

interface DailyChallengesProps {
  challenges: Challenge[];
  onSelectChallenge: (challengeId: number) => void;
}

export const DailyChallenges = ({ challenges, onSelectChallenge }: DailyChallengesProps) => {
  return (
    <Card className="glass-card">
      <CardHeader>
        <CardTitle className="text-lg">Daily Challenges</CardTitle>
        <CardDescription>Complete these quick exercises</CardDescription>
      </CardHeader>
      <CardContent>
        <ul className="space-y-3">
          {challenges.map((challenge) => (
            <motion.li
              key={challenge.id}
              whileHover={{ x: 5 }}
              onClick={() => onSelectChallenge(challenge.id)}
              className={`flex items-center p-3 rounded-lg transition-colors cursor-pointer ${
                challenge.isActive 
                  ? 'bg-primary/10 text-primary' 
                  : challenge.isCompleted
                    ? 'bg-green-50 text-green-600'
                    : 'hover:bg-secondary'
              }`}
            >
              <div className="w-10 h-10 rounded-full flex items-center justify-center mr-3 bg-white/80 shadow-sm">
                {challenge.icon}
              </div>
              <div>
                <p className="font-medium">{challenge.title}</p>
                <p className="text-xs text-muted-foreground">{challenge.description}</p>
              </div>
            </motion.li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
